import { ModalDialog } from '@front10/base-elements';
import { OverlayContainer } from '@react-aria/overlays';
import { useOverlayTriggerState } from '@react-stately/overlays';
import * as React from 'react';
import Button from '../../../packages/base-elements/Button2';
import { CloseButton } from '../../../packages/base-elements/CloseButton';
import { ContactPanel } from './ContactPanel';
import { useTranslation } from '@front10/utils';

interface ContactButtonProps {
  data: React.ComponentPropsWithoutRef<typeof ContactPanel> & { ctaLabel?: string };
  onClick?: () => void;
  autoFocus?: boolean;
  componentName?: string;
  contactEmail?: string;
  notifyChange?: (value: boolean) => void;
}

const contactUs = 'Contact Us';

export function ContactButton({
  data,
  onClick,
  autoFocus,
  componentName = 'premium-experience-grid',
  contactEmail,
  notifyChange = (e) => {}
}: ContactButtonProps) {
  let state = useOverlayTriggerState({});
  const translate = useTranslation();

  React.useEffect(() => {
    notifyChange(state.isOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isOpen]);

  return (
    <>
      <Button
        onPress={() => {
          state.open();
          onClick?.();
        }}
        autoFocus={autoFocus}
        variant="primary"
      >
        {data.ctaLabel || translate(`cmp-${componentName}-contactUs`, contactUs)}
      </Button>
      {state.isOpen && (
        <OverlayContainer>
          <ModalDialog isOpen onClose={state.close} isDismissable>
            <CloseButton variant="closeInverted" onPress={() => state.close()} />
            <ContactPanel
              contactEmail={contactEmail}
              componentName={componentName}
              {...data}
              sx={{ maxWidth: '604px' }}
            />
          </ModalDialog>
        </OverlayContainer>
      )}
    </>
  );
}
